import Lenis from "lenis";
import 'add-to-calendar-button';
import 'lenis/dist/lenis.css';
import "../scss/main.scss";
const accordion = document.querySelectorAll(".accordion");
const mobileMenuItemParents = document.querySelectorAll("#mobile-menu .mobile-menu__navigation nav > ul > li.menu-item-has-children");
const menuToggle = document.getElementById('menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');
const siteHeader = document.getElementById('site-header');

// Initialize Lenis
const lenis = new Lenis({
});

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

if (document.body.dataset.smooth === '1') {
    lenis.start();

    const getOffset = () => {
        let offSet = 25;

        if (siteHeader) {
            offSet += siteHeader.offsetHeight;
        }

        console.log(offSet);

        return offSet * -1;
    };

    // Handle in-page anchor clicks
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            const target = document.querySelector(anchor.getAttribute('href'));

            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, {
                    offset: getOffset(),
                });
            }
        });
    });

    // Handle hash links from other pages (on load)
    window.addEventListener('load', () => {
        if (window.location.hash) {
            const target = document.querySelector(window.location.hash);

            if (target) {
                // Small delay ensures layout is ready
                setTimeout(() => {
                    lenis.scrollTo(target, {
                        offset: getOffset(),
                    });
                }, 200);
            }
        }
    });

} else {
    lenis.destroy();
}

document.addEventListener("DOMContentLoaded", () => {
    if ( accordion.length > 0) {
        accordion.forEach(a => {
            const header = a.querySelector(".accordion__header");
            const panel = header.nextElementSibling;

            header.addEventListener("click", function(e) {
                a.classList.toggle("active");
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    panel.style.marginTop = '0px';
                } else {
                    panel.style.marginTop = '1rem';
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        });
    }

    if ( menuToggle && mobileMenu ) {
        menuToggle.addEventListener("click", function() {
            this.classList.toggle("active");
            mobileMenu.classList.toggle("active");
            document.body.classList.toggle("no-scroll");
        })
    }

    if ( mobileMenuItemParents.length > 0 ) {
        mobileMenuItemParents.forEach(menuItem => {
            const subMenu = menuItem.querySelector("ul.sub-menu");
            menuItem.addEventListener("click", function(e) {
                e.preventDefault();
                this.classList.toggle("active");
                subMenu.classList.toggle("active");

                if (subMenu.style.maxHeight) {
                    subMenu.style.maxHeight = null;
                    subMenu.style.marginTop = '0px';
                } else {
                    subMenu.style.marginTop = '1rem';
                    subMenu.style.maxHeight = subMenu.scrollHeight + "px";
                }
            })
        })
    }
})